export default __webpack_public_path__ + "static/media/figleaf2.d1de4849.png";